<template>
  <div class="park-tradtxlog">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd"
              :value="datePic"
              @on-change="changeSearchDate"
              style="width: 200px"
              placeholder="开始时间 - 结束时间"
            ></DatePicker>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Row>
      <Col :xs="8" :sm="8">
        <Alert>园区账户余额：¥{{ park_money }}</Alert>
        <div style="float: left;"></div>
      </Col>
      <Col :xs="8" :sm="8">
        <Alert>园区已提现金额：¥{{ tx_money }}</Alert>
        <div style="float: left;"></div>
      </Col>
    </Row>
    <Table border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.page"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "park-tradtxlog",
  data() {
    return {
      tradesman: {},
      loading: true,
      txStatus: false,
      dataloading: true,
      datePic: [],
      params: {
        datetime: []
      },
      park_money: "0.00",
      txtrad_money: "0.00",
      tx_money: "0.00",
      title: "",
      pages: {
        page: 1,
        size: 10
      },
      formItem: {
        key: "",
        status: ""
      },
      list: [
        {
          title: "Id",
          key: "id",
          width: 90
        },
        {
          title: "申请人",
          key: "name",
          width: 200
        },
        {
          title: "类型",
          key: "apply_type",
          width: 90
        },
        {
          title: "申请金额",
          key: "apply_money",
          width: 100
        },
        {
          title: "服务费",
          key: "service_money",
          width: 100
        },
        {
          title: "实际到账",
          key: "money",
          width: 150
        },
        {
          title: "银行卡",
          key: "bankcard",
          width: 250
        },
        {
          title: "批次号",
          key: "batch_no",
          width: 150
        },
        {
          title: "申请时间",
          key: "created_at",
          width: 150
        },
        {
          title: "审核状态",
          // key: 'created_at',
          minWidth: 150,
          render: (h, params) => {
            var s_name = new Array();
            s_name[-4] = "审核不通过";
            s_name[0] = "待审核";
            s_name[2] = "审核通过";
            // [-3 => '平台审核不通过'];
            return h("div", [h("span", {}, s_name[params.row.status])]);
          }
        },
        {
          title: "审核备注",
          key: "park_comment",
          width: 150
        }
      ],
      tablelist: []
    };
  },
  created: function() {
    this.id = this.$route.params.id;
    this.getTableList();
  },
  methods: {
    getTableList: function() {
      this.$api.parkmoneylog
        .parktxlist({
          page: this.pages.page,
          size: this.pages.size,
          park_uuid: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.park_money = res.result.park_money;
            this.tx_money = res.result.tx_money;
            this.$Message.success(res.msg);
          }
        });
      return;
    },
    changeSearchDate(val) {
      this.params.datetime = val;
    },
    // 翻页
    changePage() {
      this.pages.page = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.page = 1;
      }
      this.$api.parkmoneylog
        .parktxlist({
          page: this.pages.page,
          size: this.pages.size,
          park_uuid: this.id
        })
        .then(res => {
          this.dataloading = false;
          if (res.code == 200) {
            this.tablelist = res.result.list;
            this.pages.total = res.result.total;
            this.park_money = res.result.park_money;
            this.tx_money = res.result.tx_money;
            this.$Message.success(res.msg);
          }
        });
      return;
    }
  }
};
</script>
